import { CommonModule } from '@angular/common';
import { Component, ChangeDetectionStrategy } from '@angular/core';

/**
 * Platform-agnostic phone shell for the mobile preview variants. Draws the
 * device outline and clips whatever it wraps, so a long headline or a tall
 * image can't spill past the border.
 *
 * Content goes in three slots: `frameTop` and `frameBottom` are pinned (app
 * chrome — navbars, tab bars), while the default slot is the screen body and
 * absorbs the leftover height.
 */
@Component({
    selector: 'app-mobile-frame',
    imports: [CommonModule],
    templateUrl: './mobile-frame.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './mobile-frame.component.scss'
})
export class MobileFrameComponent {}
